export default __webpack_public_path__ + "static/media/premiumBedge.44126a3a.png";